import "./plugins/extends";
import Vue from 'vue'
import router from "@/router";
import App from './App.vue'
import vuetify from './plugins/vuetify';
import {store} from '@/store';
import Vuelidate from "vuelidate";
import helper from './plugins/helper';
import {AxiosPlugin} from './plugins/axios'
import "./assets/css/style.css";

Vue.use(AxiosPlugin);
Vue.use(Vuelidate);
Vue.use(helper);

window.alert = function(text){
    store.commit("snackbar",text);
}
Vue.config.productionTip = false
store.commit("setRouter",router);
new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')
